export const SIDEBAR_STATE_STORAGE_KEY = 'sideMenuOpen';
